export const telephoneNumbers = {
  customerServices: '0333 004 0941',
  newSales: '0333 004 0940',
  businessDevelopmentManager: '03330 30 83 89', // ????
  newPolicies: '0333 004 0940',
  renewals: '0333 004 0942',
  claims: '0333 004 0939',
  claimSupport: '0333 004 0939',
  vetSupport: '03330 30 83 90', // ???
  rehomingSupport: '03330 30 83 89', // ??
  breederSupport: '03330 30 83 75', // ??
  illnessInjurySupport: '0333 004 0944',
} as const;
